module.exports = __webpack_public_path__ + "img/twitter.fd5c65f6.png";